import { Account } from '../types/Account'
import { Language } from '../../../types/user/User'
import { fetchAccounts } from '../service/accountService'
import accountQueryKeys from './accountQueryKeys'

export type SelectorFunction<TData, Params> = (data: Account[], params: Params) => TData

export interface FetchAccountsProps {
  code?: number
  lng?: Language
}

export const getAccountOptions = <TData = Account[], Params extends FetchAccountsProps = FetchAccountsProps>(
  companyId?: string,
  lng = Language.fi,
  selectFunction?: SelectorFunction<TData, Params>,
  params?: Params
) => {
  const finalParams = {
    code: params?.code,
    lng
  } as Params

  return {
    queryKey: accountQueryKeys.list({ companyId }),
    queryFn: fetchAccounts,
    enabled: !!companyId,
    gcTime: 1000 * 60,
    staleTime: 1000 * 60,
    select: (data: Account[]) => (selectFunction ? selectFunction(data, finalParams) : (data as TData))
  }
}
